            
<template>  
  <div>
    <div class="modalsave" v-show="saveConfig.capa"></div>
    <div>
      <validation-observer v-slot="{ invalid }">      
      <b-form inline style="margin-bottom:15px;padding-left:10px;padding-right:10px;" novalidate > 
              <validation-provider rules="required" immediate
                name="planilla" style="position:relative;width:100%">         
                <b-input-group size="md" prepend="No de planilla" >
                  <b-form-input  v-model="registroPlanilla.planilla" ></b-form-input>
                </b-input-group> 
              </validation-provider>
      </b-form>        
      <footer id="modal-1___BV_modal_footer_" class="modal-footer" style="margin: 0 -15px; padding: 0">
            <sw-saveform
              :index="dataIndex[namePath]"
              nameBtn="Quitar # planilla"
              :invalid="invalid"
              @save="save"
              >
            </sw-saveform>
      </footer>
    </validation-observer>
    </div>
  </div> 
</template>
<script>
import { mapActions } from "vuex"
import SwInputs  from '@/components/forms/inputs.vue'
import SwSaveform from '@/components/forms/saveForm.vue'
import { ValidationProvider } from 'vee-validate'
import VueNumeric   from '@/components/vue-numeric/vue-numeric.vue'
export default 
{
  name: 'swmodalasesores',
  components: {
    SwInputs,
    SwSaveform,
    ValidationProvider,
    VueNumeric,
  },
  props: {
    nameInactive: {
      type: String,
      default: ''
    },
    prioridad: {
      type: Boolean,
      default: false
    }
  },
  data()
  {
    return {
      registroPlanilla: {
        planilla: null,
      },
    }
  },
  async created()
  {
    await this.updateGlobal({state:'openModal/modal/loaded',data:true})
  },
  methods: {
    async save(emit)
    {
      this.$emit('save', { save: emit.save, ftn: 'quitarPLanillaFtn', data: this.registroPlanilla })
    },
  }
}
</script>
<style>
</style>